export const cleanDataGridNames = (value: any): any =>
  (typeof value === 'string' && cleanGridNameDictionary[value]) || value;

export const decleanDataGridNames = (value: any): any =>
  (typeof value === 'string' && uncleanGridNamDictionary[value]) || value;

const cleanGridNameDictionary = {
  'destinationAccount.name': 'destinationAccount',
  'sourceAccount.name': 'sourceAccount',
  'escrowFile.depositEscrowBankAccount.name': 'bankAccountName',
  'escrowFile.depositEscrowBankAccount.nickname': 'bankAccountName',
  'escrowFile.depositEscrowBankAccount.spruceName': 'bankAccountName',
  'escrowFile.depositEscrowBankAccount.legalName': 'bankAccountName',
  'escrowFile.order.fileNumber': 'fileNumber',
  'escrowFile.order.propertyAddress': 'propertyAddress',
  'wireDetail.obi': 'obi',
  'wireDetail.org': 'org',
  'escrowFile.order': 'borrowerName',
};

const uncleanGridNamDictionary = Object.keys(cleanDataGridNames).map((k) => ({ [cleanDataGridNames[k]]: k }));
